import React from 'react';
import { CardBody, CardHeader } from 'reactstrap';
import domain from 'src/config/domain';

const CountryTransactions = ({ data, loading }) => {
  const domainConfig = domain();

  if (loading || !data?.transactions?.location) {
    return <React.Fragment />;
  }

  // Ensure values are numbers for calculations
  const maxTransactions = Math.max(...data.transactions.location.map(item => Number(item.item_count)));
  const totalTransactions = data.transactions.location.reduce((sum, item) => sum + Number(item.item_count), 0);

  return (
    <div className="flex flex-col rounded-md border animate-in fade-in-50 mt-2">
      <CardHeader className="bg-gray-50 mb-0 py-3">
        <div className="float-right text-sm pt-0">
          <span className={`inline-flex items-center gap-x-1.5 py-1.5 px-3 rounded-md text-xs font-medium border ${domainConfig.styles.borderColour} ${domainConfig.styles.lightBGColour} ${domainConfig.styles.textColour}`}>Last 30 Days</span>
        </div>
        <h2 className={`text-xl pt-0.5 ${domainConfig.styles.textColour}`}>
          Transactions <span className="font-bold">By Location</span>
        </h2>
      </CardHeader>

      <CardBody className="p-0">
        <div className="divide-y divide-slate-100">
          {data.transactions.location.map((item, index) => {
            const itemCount = Number(item.item_count);
            const percentage = (itemCount / maxTransactions) * 100;
            const sharePercentage = ((itemCount / totalTransactions) * 100).toFixed(1);

            return (
              <div
                key={index}
                className="relative px-4 py-3 hover:bg-slate-50/50 transition-colors group"
              >
                {/* Animated background bar */}
                <div
                  className="absolute inset-y-0 left-0 bg-gradient-to-r from-violet-100 via-violet-50 to-transparent opacity-60 group-hover:opacity-80 transition-all duration-300"
                  style={{
                    width: `${percentage}%`,
                  }}
                />

                <div className="relative flex items-center justify-between gap-4">
                  <div className="flex items-center gap-3 min-w-0 flex-1">
                    {/* Rank indicator */}
                    <div className={`flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold ${
                      index === 0 ? 'bg-violet-600 text-white' :
                      index === 1 ? 'bg-violet-400 text-white' :
                      index === 2 ? 'bg-violet-300 text-violet-800' :
                      'bg-slate-200 text-slate-600'
                    }`}>
                      {index + 1}
                    </div>

                    <div className="min-w-0">
                      <p className="font-medium text-slate-800 truncate">
                        {item.area.split(',')[0]}
                      </p>
                      <p className="text-xs text-slate-500 truncate">
                        {item.area.split(', ')[1]}
                      </p>
                    </div>
                  </div>

                  <div className="flex items-center gap-4 flex-shrink-0">
                    <div className="text-right">
                      <p className="font-semibold text-slate-800">
                        {new Intl.NumberFormat('en-GB').format(itemCount)} <small className="text-slate-500">transactions</small>
                      </p>
                      <p className="text-xs text-slate-500">
                        <strong>{sharePercentage}%</strong> <small> share of total</small>
                      </p>
                    </div>

                    <div className="text-right min-w-[80px]">
                      <p className="font-medium text-emerald-600">
                        {new Intl.NumberFormat('en-GB', {
                          style: 'currency',
                          currency: 'GBP',
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0,
                        }).format(item.total_value)}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </CardBody>
    </div>
  );
};

export default CountryTransactions;